import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { GenCurrency } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';

const ServicesDetails = ({
  data,
  isLoadingVehicle = false,
  photoCount = null,
  showPhotoCount = false,
}) => {
  const { t } = useTranslation('orders');
  const { orderId } = data;
  return (
    <Box
      flexGrow={1}
      display="flex"
      flexDirection="column"
      p={{ xs: 2, md: 0 }}
      gap={2}
    >
      <Box>
        <Typography variant="subtitle2">
          {t('tableHeaders.services')}:
        </Typography>
        {(data.services || []).map(service => (
          <Box
            key={service.serviceId}
            display="flex"
            gap={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack
              direction="row"
              gap={1}
              alignItems="center"
              justifyContent="flex-start"
            >
              <Typography variant="body2">{`${service.quantity}x`}</Typography>
              <Typography variant="body2">{service.name}</Typography>
              <Typography variant="body2">
                {'('}
                <GenCurrency value={service.price} />
                {')'}
              </Typography>
            </Stack>
            <Typography variant="body2">
              <GenCurrency value={service.amount} />
            </Typography>
          </Box>
        ))}
      </Box>
      {(isLoadingVehicle || photoCount?.[orderId] !== null) &&
        data?.vehicle?.showPhotoCount && (
          <Stack>
            {showPhotoCount && (
              <Typography variant="subtitle2">Photo Count:</Typography>
            )}
            <Typography variant="body2">
              {isLoadingVehicle ? (
                <CircularProgress
                  size={16}
                  color="inherit"
                  data-testid="progressbar"
                />
              ) : (
                photoCount?.[orderId]
              )}
            </Typography>
          </Stack>
        )}
    </Box>
  );
};

export default ServicesDetails;
